<template>
  <section>
    <!--工具条-->
    <SendOrderToolbar :buttonList="buttonList" @callFunction="callFunction"></SendOrderToolbar>

    <!--列表-->
    <el-table :data="sendOrderList" highlight-current-row v-loading="listLoading"
      @current-change="selectCurrentRow" style="width: 100%;">
      <el-table-column fixed="left" type="index" label="序号" width="60"></el-table-column>
      <el-table-column fixed="left" label="操作" width="80">
        <template slot-scope="scope">
          <span v-for="item in operationButtonList" :key="item.id">
            <el-button type="text" style="padding-right:6px;" size="small" v-if="!item.IsHide"
              @click="operationButtonFunction(item, scope.row)">{{ item.name }}</el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column fixed="left" prop="CustomName" label="客户名称" width="120"></el-table-column>
      <el-table-column fixed="left" prop="cph" label="车牌号" width="100"></el-table-column>
      <el-table-column prop="ModifyOrder" fixed="left" label="修改单" width="70">
        <template slot-scope="scope">
          <el-tag :type="scope.row.ModifyOrder ? 'success' : 'danger'" disable-transitions>{{ scope.row.ModifyOrder ?
            "是" : "否" }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="CancelOrder" fixed="left" label="作废单" width="70">
        <template slot-scope="scope">
          <el-tag :type="scope.row.CancelOrder ? 'success' : 'danger'" disable-transitions>{{ scope.row.CancelOrder ?
            "是" : "否" }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="SendOrderInPolygon" label="厂区发货" width="80">
        <template slot-scope="scope">
          <el-tag :type="scope.row.SendOrderInPolygon ? 'success' : 'danger'" disable-transitions>{{ scope.row.SendOrderInPolygon ?
            "是" : "否" }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="LeaveFactory" label="是否出过厂" width="90">
        <template slot-scope="scope">
          <el-tag :type="scope.row.LeaveFactory ? 'success' : 'danger'" disable-transitions>{{ scope.row.LeaveFactory ?
            "出过" : "未出过" }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="LeaveFactoryTime" label="出厂时间" width="160"></el-table-column>
      <el-table-column prop="EndSend" label="GPS发送状态" width="110">
        <template slot-scope="scope">
          <el-tag :type="scope.row.EndSend ? 'success' : 'danger'" disable-transitions>{{ scope.row.EndSend ?
            "发送结束" : "发送中" }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="EndSendTime" label="发送结束时间" width="160"></el-table-column>
      <el-table-column prop="id" label="发货单ID" width="320" ></el-table-column>
      <el-table-column prop="jbcch" label="搅拌车车号" width="120" ></el-table-column>
      <el-table-column prop="fhdbh" label="发货单编号" width="150" ></el-table-column>
      <el-table-column prop="rwdbh" label="任务单编号" width="150" ></el-table-column>
      <el-table-column prop="sgdw" label="施工单位" width="300" ></el-table-column>
      <el-table-column prop="gcmc" label="工程名称" width="300" ></el-table-column>
      <el-table-column prop="rqsj" label="日期时间" width="180" ></el-table-column>
      <el-table-column prop="sgbw" label="施工部位" width="300" ></el-table-column>
      <el-table-column prop="gddz" label="工地地址" width="300" ></el-table-column>
      <el-table-column prop="jzfs" label="浇筑方式" width="100" ></el-table-column>
      <el-table-column prop="qddj" label="强度等级" width="100" ></el-table-column>
      <el-table-column prop="xsfl" label="销售方量" width="100" ></el-table-column>
      <el-table-column prop="ljxsfl" label="累计销售方量" width="130" ></el-table-column>
      <el-table-column prop="Signature" label="签名" width="300" ></el-table-column>
      <el-table-column prop="CreateTime" label="创建时间" width="180" ></el-table-column>
      <el-table-column prop="Ip" label="Ip" width="200" ></el-table-column>
      <el-table-column prop="Result" label="结果" width="1200" ></el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="Toolbar">
      <el-pagination layout="total, sizes, prev, pager, next" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page.sync="page" :page-sizes="[10, 15, 20, 50, 100, 200]"
        :total="total" style="float:right;"></el-pagination>
    </el-col>

    <!--操作日记-->
    <el-dialog title="操作日记" :visible.sync="operateDataLogFormVisible" v-model="operateDataLogFormVisible"
      :close-on-click-modal="false" :destroy-on-close="true" width="60%">
      <OperateDataLog v-if="operateDataLogFormVisible" :entityName="entityName" :entityKey="entityKey"></OperateDataLog>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="operateDataLogFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import { getSendOrderListPage, addSendGpsVehicle, deleteSendGpsVehicle } from "../../api/api";
import { getButtonList, getOperationButtonList } from "../../promissionRouter";
import SendOrderToolbar from "../../components/QueryToolbar/SendOrderToolbar";
import OperateDataLog from "../../components/OperateDataLog";

export default {
  components: { SendOrderToolbar, OperateDataLog },
  data() {
    return {
      filters: {
        customerId: "",
      },
      entityName: 'SendOrder', //操作日记中的表名称
      entityKey: '',  //操作日记中的表的Id
      buttonList: [],
      operationButtonList: [],
      sendOrderList: [], //发货单列表
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      operateDataLogFormVisible: false, //查看操作日记界面是否显示
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        customerId: item.customerId,
      };
      this[item.Func].apply(this, item);
    },
    operationButtonFunction(item, row) {
      this.currentRow = row;
      this[item.Func].apply(this, item);
    },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getSendOrder();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getSendOrder();
    },
    querySendOrder() {
      this.page = 1;
      this.getSendOrder();
    },
    //获取发货单列表
    getSendOrder() {
      let _this = this;
      let para = {
        customerId: _this.filters.customerId,
        page: _this.page,
        pageSize: _this.pageSize
      };
      _this.listLoading = true;
      getSendOrderListPage(para).then(res => {
        _this.total = res.data.response.dataCount;
        _this.sendOrderList = res.data.response.data;
        _this.listLoading = false;
      });
    },
    // 添加需要发送gps的车
    handleAddSendGpsVehicle() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要启动gps发送数据的一行！",
          type: "error"
        });

        return;
      }
      this.$confirm("确认启动gps发送数据吗?", "提示", {
        type: "warning"
      })
        .then(() => {
          let para = { sendOrderId: row.SendOrderId };
          addSendGpsVehicle(para).then(res => {
            if (util.isEmt.format(res)) {
              return;
            }
            if (res.data.success) {
              this.$message({
                message: "启动gps发送数据成功",
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }

            this.getSendOrder();
          });
        })
        .catch(() => { });
    },
    //停止GPS发送
    handleDeleteSendGpsVehicle() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要停止GPS发送的一行数据！",
          type: "error"
        });

        return;
      }
      this.$confirm("确认停止GPS发送吗?", "提示", {
        type: "warning"
      })
        .then(() => {
          this.listLoading = true;
          let para = { sendOrderId: row.SendOrderId };
          deleteSendGpsVehicle(para).then(res => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }

            this.getSendOrder();
          });
        })
        .catch(() => { });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //查看操作日记
    lookUpOperateDataLog() {
      this.operateDataLogFormVisible = true;
      this.entityKey = this.currentRow.SendOrderId;
    },
    //批量删除
    batchRemove: function () {
      this.$message({
        message: "该功能未开放",
        type: "warning"
      });
    },
    getButtonList2(routers) {
      let _this = this;
      routers.forEach(element => {
        let path = this.$route.path.toLowerCase();
        if (element.path && element.path.toLowerCase() == path) {
          _this.buttonList = element.children;
          return;
        } else if (element.children) {
          _this.getButtonList(element.children);
        }
      });
    }
  },
  mounted() {
    this.getSendOrder();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
    this.operationButtonList = getOperationButtonList(this.$route.path, routers);
  }
}
</script>

<style scoped></style>
